import React, { useEffect, useState } from 'react';

import { useAuth } from '../../hooks/useAuth';
import { LocalStorageService } from '../../providers/local-storage-service';
import { AuthConstants } from '../../providers/auth-constants';
import { useContentStore } from "../../providers/stores/content-store";
import { isNullOrEmpty, isNullOrEmptyString, isNullOrUndefined } from '../../helpers';
import { ValidationMessages } from '../common/ValidationMessages';

import logger from 'debug';

const debug = logger('login:loginPage');

export const Login = () => {
	const authenticationContent = useContentStore(state => state.authenticationContent(state));

	const { login } = useAuth();

	const [userName, setUserName] = useState('');
	const [password, setPassword] = useState('');
	const [rememberMe, setRememberMe] = useState(true);
	const [validation, setValidation] = useState([]);

	useEffect(() => {
		let userName = LocalStorageService.getFromLocalStorage(AuthConstants.UserName_LocalStorage_Key);
		if (!isNullOrEmptyString(userName))
			setUserName(userName);
	}, []);

	const handleLogin = async (event) => {
		event.preventDefault();

		const loginResponse = await login({ userName, password, rememberMe });
		if (!isNullOrUndefined(loginResponse)) {
			debug('loginResponse: ', loginResponse);
			setValidation(['User Name or Password invalid.']);
		}

		return false;
	};

	return (
		<form id="login-form" onSubmit={handleLogin} className="clearfix pad20">

			{!isNullOrEmpty(validation) &&
				<ValidationMessages header="Error(s):" messages={validation} />
			}

			<label>{authenticationContent.userNameLabel}</label>
			<div className="textWrapper">
				<input name="userName" tabIndex={1} value={userName} onChange={(event) => setUserName(event.target.value)} placeholder="User Name" />
			</div>

			<label>{authenticationContent.passwordLabel}</label>
			<div className="textWrapper">
				<input name="password" type="password" tabIndex={2} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Password" />
			</div>

			<div className="clearfix rememberMe">
				<label>{authenticationContent.rememberMeLabel}</label>
				<input type="checkbox" checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} />
			</div>

			<div className="forgotCredentials">
				{authenticationContent.forgotCredentialsLabel} <a href="/forgot" rel="nofollow">Click here</a>
			</div>

			<input type="hidden" />
			{/* @Html.HiddenFor(m => m.ReturnUrl) */}

			<button type="submit">{authenticationContent.signInButton}</button>
		</form >
	);
};